import { render, staticRenderFns } from "./AuctionEdit.vue?vue&type=template&id=dc2b0e6a&"
import script from "./AuctionEdit.vue?vue&type=script&lang=js&"
export * from "./AuctionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports